import { Injectable } from '@angular/core';
import { TextChatsService } from '../text-chats/text-chats.service';
import { TextChat } from '../xislivechat/models/text-chat';
import { DynamicQueryStoreObservableFactory } from 'common/dynamicquery/dynamic-query-store-observable';

@Injectable()
export class TextChatsStoreFactoryService {

  constructor(private textChatsService: TextChatsService,
              private dynamicQueryStoreObservableFactory: DynamicQueryStoreObservableFactory) {
  }

  /**
   * Creates an Array Store Observable but for only one text chat.
   * @param {String} textChatId
   * @throws Error 'Missing textChatId'
   * @returns {Observable<Array<TextChat>>}
   */
  createForSingleTextChat(textChatId) {
    const activeTextChats = this.textChatsService.observeTextChatByTextChatId(textChatId);
    // TODO: It can be replaceable by an ObjectStoreObservable
    return this.dynamicQueryStoreObservableFactory.create(activeTextChats, TextChat.comparator);
  }
}
